import formatErrors from '../../../functions/formatErrors';
import { LoginState } from '../objects/loginState';
import {
    LoginActionTypes,
    SET_ERRORS,
    TOGGLE_FORGOT_PASSWORD,
    TOGGLE_FORGOT_PASSWORD_EMAIL_SENT,
    TOGGLE_PASSWORD,
    UPDATE_EMAIL,
    UPDATE_PASSWORD
} from './actionTypes';

const initialState: LoginState = {
    email: '',
    email_error: '',
    forgot_password: false,
    forgot_password_email_sent: false,
    password: '',
    password_error: '',
    show_password: false
};

export default (state = initialState, action: LoginActionTypes): LoginState => {
    switch (action.type) {
        case UPDATE_EMAIL: {
            return {...state, email: action.payload};
        }
        case UPDATE_PASSWORD: {
            return {...state, password: action.payload};
        }
        case TOGGLE_FORGOT_PASSWORD: {
            return {...state, forgot_password: !state.forgot_password, forgot_password_email_sent: false};
        }
        case TOGGLE_FORGOT_PASSWORD_EMAIL_SENT: {
            return {...state, forgot_password_email_sent: true};
        }
        case TOGGLE_PASSWORD: {
            return {...state, show_password: !state.show_password};
        }
        case SET_ERRORS: {
            const { email, password } = action.payload;
            return {
                ...state,
                email_error: email ? Array.isArray(email) ? formatErrors(email) : email : '',
                password_error: password ? Array.isArray(password) ? formatErrors(password) : password : ''
            };
        }
        default:
            return state;
    }
};